import { Star } from "lucide-react";

export const Stars = ({ value, onChange, size = 16, testid = "stars" }) => (
  <div className="inline-flex gap-1" data-testid={testid} role={onChange ? "radiogroup" : "img"} aria-label={`${value || 0} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((n) => {
      const icon = <Star size={size} className={n <= (value || 0) ? "fill-amber-300 text-amber-300" : "text-neutral-600"} />;
      return onChange ? (
        <button key={n} type="button" onClick={() => onChange(n)} aria-label={`${n} star${n > 1 ? "s" : ""}`}
          aria-checked={value === n} role="radio" data-testid={`${testid}-${n}`} className="p-0.5 hover:scale-110 transition-transform">
          {icon}
        </button>
      ) : <span key={n}>{icon}</span>;
    })}
  </div>
);
